<template>
<div class="chapter">
<div class="inner_page">
<p class="C118_14"><a id="page_v">CONTENTS</a></p><a id="page_v">
</a><p class="C124_15"><a id="page_v"><em></em></a><em><a href="#/xhtml/05_Preface_#page_vii">Preface, W. J. T. Mitchell</a></em></p>
<p class="C118_3a"><a href="#/xhtml/07_I__M_SO#page_3">I’M SO ANGRY I MADE A SIGN</a></p>
<p class="C125">Michael Taussig</p>
<p class="C118_3a"><span href="#/xhtml/08_POLITICA#page_45" title="Link target outside of Sample">POLITICAL DISOBEDIENCE</span></p>
<p class="C125">Bernard E. Harcourt</p>
<p class="C118_16"><span href="#/xhtml/09_IMAGE__S#page_93" title="Link target outside of Sample">IMAGE, SPACE, REVOLUTION</span> <em><span href="#/xhtml/09_IMAGE__S#page_93" title="Link target outside of Sample">The Arts of Occupation</span></em></p>
<p class="C125">W. J. T. Mitchell</p>
<p class="C118_16"><span href="#/xhtml/10_Note" title="Link target outside of Sample"><em>Notes</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?aecf98cc